export const I18N_COOKIE_NAME = "i18nextLng";

export const LANGUAGES_OPTIONS = [
  { value: "en", label: "English" },
  { value: "th", label: "Thai" },
];
